import type { StaticTextResource } from '../keys'

export const my: StaticTextResource = {
  'schedule.dueToday': 'ယနေ့ {{time}} အထိ',
  'schedule.dueTomorrow': 'မနက်ဖြန် {{time}} အထိ',
  'schedule.durationRange':
    '{{start}} - {{end}} (ရက် {{currentDay}} / {{days}} ရက်)',
  'editReport.defaultPageName': 'စာမျက်နှာ {{n}}',
  'editReport.defaultSectionName': 'အပိုင်း',
  'editReport.defaultRepeatSectionName': 'ထပ်ခါတလဲလဲ အပိုင်း',
}
